<template>
  <div class="container">
    <div>
      <b-form
        @submit.stop.prevent="onSubmit"
        :class="{
          'p-3 box-shadow2 rounded': !isDarkMode,
          'dark-div p-3 box-shadow2 rounded': isDarkMode
        }"
      >
        <b-row>
          <b-col class="mt-3 pt-2">
            <h4 class="page-title text-center">{{
              formType === 'new' ? 'Certificate Details' : 'Update Certificate'
            }}</h4>
            <b-row>
              <b-col>
                <b-row>
                  <b-col sm="12" lg="6">
                    <b-form-group id="group-products" label-for="input-products">
                      <template v-slot:label>
                        Select Store
                        <span class="text-danger">*</span>
                      </template>
                      <multiselect
                        :class="{ 'box-shadow3': !isDarkMode, darkMode: isDarkMode }"
                        placeholder="Select Store Id"
                        v-model="selectedStore"
                        :options="stores"
                        label="text"
                        track-by="id"
                      ></multiselect>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group id="group-company-petty" label-for="input-company-petty">
                      <template v-slot:label>Company Name</template>
                      <multiselect
                        :class="{
                          'box-shadow3': !isDarkMode,
                          darkMode: isDarkMode
                        }"
                        id="input-company"
                        :options="['SRL', 'NBL', 'CESC']"
                        v-model="form.company"
                        placeholder="Select Company"
                      ></multiselect>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" lg="6">
                <b-form-group id="group-dc-cash" label-for="input-dc-cash">
                  <template v-slot:label>
                    DC Cash
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    :class="{
                      'box-shadow3 bg-light text-dark': !isDarkMode,
                      'bg-dark text-light placeholder-light': isDarkMode
                    }"
                    id="input-dc-cash"
                    type="number"
                    v-model="form.mainCash"
                    placeholder="Enter DC Cash"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="12" lg="6">
                <b-form-group id="group-float-cash" label-for="input-float-cash">
                  <template v-slot:label>
                    Float Cash
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    :class="{
                      'box-shadow3 bg-light text-dark': !isDarkMode,
                      'bg-dark text-light placeholder-light': isDarkMode
                    }"
                    id="input-float-cash"
                    type="number"
                    v-model="form.floatCash"
                    placeholder="Enter Float Cash"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-float-cash-invalid">
                    Please enter Float Cash.
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" lg="6">
                <b-form-group id="group-petty-cash" label-for="input-petty-cash">
                  <template v-slot:label>
                    Petty Cash
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    :class="{
                      'box-shadow3 bg-light text-dark': !isDarkMode,
                      'bg-dark text-light placeholder-light': isDarkMode
                    }"
                    id="input-petty-cash"
                    type="number"
                    v-model="form.pettyCash"
                    placeholder="Enter Petty Cash"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="group-quarter" label-for="input-quarter">
                  <template v-slot:label>
                    Quarter
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    :class="{
                      'box-shadow3 bg-light text-dark': !isDarkMode,
                      'bg-dark text-light placeholder-light': isDarkMode
                    }"
                    id="input-quarter"
                    type="number"
                    v-model="form.quarter"
                    placeholder="Enter Quarter"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-quarter-invalid"> Please enter Quarter. </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-form-group>
          <b-row class="mt-3">
            <b-col class="text-right">
              <b-button
                class="box-shadow2"
                type="submit"
                size="sm"
                :variant="isDarkMode ? 'outline-success' : 'success'"
              >
                <font-awesome-icon :icon="['fas', 'save']" class="mr-1" />Save
              </b-button>
              <b-button
                class="ml-2 box-shadow2"
                size="sm"
                :variant="isDarkMode ? 'outline-warning' : 'warning'"
                :to="{ path: `/petty-cash/certificate/cc/upload` }"
              >
                <font-awesome-icon :icon="['fas', 'long-arrow-alt-left']" class="mr-1" />Back to list
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </div>
  </div>
</template>

<script>
import router from '@/router';
import Vue from 'vue';
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';
import Multiselect from 'vue-multiselect';
import ccListBox from './ccListBox.vue';

export default {
  name: 'CashCertificateFormBox',
  components: {
    Multiselect,
    ccListBox
  },
  props: {
    formType: String
  },
  data() {
    return {
      stores: [],
      selectedStore: null,
      form: {
        storeName: '',
        storeid: '',
        company: '',
        mainCash: '',
        floatCash: '',
        pettyCash: '',
        quarter: ''
      }
    };
  },
  validations() {
    const formValidation = {
      storeName: { required },
      storeid: { required },
      company: { required },
      mainCash: { required },
      floatCash: { required },
      pettyCash: { required },
      quarter: { required }
    };

    return { form: formValidation };
  },
  mounted() {
    this.listByUser({ router });
    if (this.$route.params.id) {
      this.getOneCertificate({ id: this.$route.params.id });
    }
  },
  computed: {
    ...mapState('darkMode', ['isDarkMode']),
    ...mapState('store', ['storeByUser']),
    ...mapState('pettyCash', ['certificate']),
    ...mapState('auth', {
      authUser: 'user'
    })
  },
  methods: {
    ...mapActions('store', ['listByUser']),
    ...mapActions('pettyCash', ['getOneCertificate']),
    handleInput(event) {
      this.form.mainCash = event.target.value.replace('-', '');
    },
    onSubmit() {
      if (
        !this.selectedStore ||
        !this.form.company ||
        !this.form.mainCash ||
        !this.form.floatCash ||
        !this.form.pettyCash ||
        !this.form.quarter
      ) {
        Vue.swal({
          title: 'Some Fields/Field are Empty',
          icon: 'error',
          text: `Please provide all Information`,
          background: this.isDarkMode ? '#464d54' : '#ffffff',
          customClass: {
            title: this.isDarkMode ? 'text-light' : 'text-dark',
            content: this.isDarkMode ? 'text-light' : 'text-dark'
          }
        });
        return false;
      }

      const [storeName, storeid] = this.selectedStore.text.split(' - ');

      const certificate = {
        storeName,
        storeid,
        company: this.form.company,
        mainCash: this.form.mainCash,
        floatCash: this.form.floatCash,
        pettyCash: this.form.pettyCash,
        quarter: this.form.quarter
      };
      if (this.formType === 'new') {
        this.$emit('add', { certificate });
      } else {
        this.$emit('edit', { certificate });
      }

      return false;
    }
  },
  watch: {
    storeByUser(newValue) {
      if (newValue !== undefined) {
        this.stores = newValue.map(store => ({ text: `${store.storeName} - ${store.storeid}`, id: store.storeid }));
        if (newValue.length === 1) {
          this.selectedStore = {
            text: `${newValue[0].storeName} - ${newValue[0].storeid}`,
            id: newValue[0].storeid
          };
        }
      }
    },
    certificate(newValue) {
      this.form = newValue;
      this.selectedStore = {
        text: `${newValue.storeName} - ${newValue.storeid}`
      };
    }
  }
};
</script>
<style>
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
</style>
<style src="vue-search-select/dist/VueSearchSelect.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
